import apps from '../appsList';

function AppsPage() {
  return (
    <section className="section">
      <div className="section-head">
        <h2>Apps</h2>
        <p>Our current lineup is small, crafted, and full of momentum.</p>
      </div>
      <div className="app-grid">
        {apps.map((app, index) => (
          <a
            className="app-card reveal"
            style={{ '--delay': `${index * 140}ms` }}
            href={`#/app/${app.slug}`}
            key={app.slug}
          >
            <div className="app-card-top">
              <span className="status">{app.status}</span>
            </div>
            <div className="app-card-title">
              <img
                className="app-card-icon"
                src={app.logo}
                alt={`${app.name} app icon`}
              />
              <h3>{app.name}</h3>
            </div>
            <p>{app.tagline}</p>
            <span className="app-link">Open details →</span>
          </a>
        ))}
      </div>
    </section>
  );
}

export default AppsPage;
